import React from "react";
import InputField, { InputFieldSize } from "../Core/InputField";
import Icon, { ICONS } from "../Core/Icons";

import TempoButton, { ButtonSize, ButtonType } from "../Core/TempoButton";
import Dropdown from "rc-dropdown";
import Menu, { Item as MenuItem } from "rc-menu";
import { SelectInfo } from "rc-menu/lib/interface";

export enum PropInputType {
  Bool,
  String,
  Code,
  Number,
}

interface Props {
  title: string;
  inputType: PropInputType;
  value: any;
  onValueChange: any;
  onViewCode?: any;
  onRemove?: any;
  onAdd?: any;
  unused?: boolean;
}

const PropRow: React.FC<Props> = (props) => {
  let leftIcon = null;
  let input = null;

  let booleanOptions = (
    <Menu
      onSelect={(info: SelectInfo) => {
        if (info.key === "True") {
          props.onValueChange(true);
        } else {
          props.onValueChange(false);
        }
      }}
      className="drop-menu"
    >
      <MenuItem key={"True"}>{"True"}</MenuItem>
      <MenuItem key={"False"}>{"False"}</MenuItem>
    </Menu>
  );

  switch (props.inputType) {
    case PropInputType.Bool:
      // @ts-expect-error TS2322
      input = (
        <Dropdown trigger={["click"]} overlay={booleanOptions}>
          <div className={"prop-dropdown"}>
            <Icon icon={ICONS.BOOLEAN} />
            <div className={"prop-dropdown-text"}>{props.value}</div>
            <Icon
              icon={ICONS.CHEVRON_DOWN}
              style={{ width: "24px", height: "24px" }}
            />
          </div>
        </Dropdown>
      );
      break;
    case PropInputType.String:
      // @ts-expect-error TS2322
      leftIcon = <Icon icon={ICONS.TEXT_STRING} />;
      // @ts-expect-error TS2322
      input = (
        <InputField
          value={props.value}
          onChange={props.onValueChange}
          inputType={"text"}
          size={InputFieldSize.Large}
          allowChanges={true}
          leftIcon={leftIcon}
        />
      );
      break;
    case PropInputType.Code:
      // @ts-expect-error TS2322
      leftIcon = <Icon icon={ICONS.CODE} />;
      // @ts-expect-error TS2322
      input = (
        <TempoButton
          text="View Code"
          type={ButtonType.Neutral}
          onClick={props.onViewCode}
          size={ButtonSize.Small}
          disabled={props.unused}
          startIcon={
            <img
              src="/icons/code.svg"
              width={20}
              height={20}
              alt="code"
              style={{ boxSizing: "initial" }}
              className="max-w-none"
            />
          }
        />
      );
      break;
    case PropInputType.Number:
      // @ts-expect-error TS2322
      leftIcon = <Icon icon={ICONS.NUMBER} />;
      // @ts-expect-error TS2322
      input = (
        <InputField
          value={props.value}
          onChange={props.onValueChange}
          inputType={"text"}
          size={InputFieldSize.Large}
          allowChanges={true}
          leftIcon={leftIcon}
        />
      );
      break;
  }

  return (
    <div className="prop-row">
      <div className="prop-row-header">
        <div className="prop-row-label">{props.title}</div>
        {props.onRemove &&
          (!props.unused || props.inputType !== PropInputType.Code) && (
            <Icon
              icon={props.unused ? ICONS.PLUS : ICONS.MINUS}
              style={{
                width: 20,
                height: 20,
                cursor: "pointer",
              }}
              onClick={props.unused ? props.onAdd : props.onRemove}
            />
          )}
      </div>
      <div className="prop-input">{input}</div>{" "}
    </div>
  );
};

export default React.memo(PropRow);
